import { Sheet } from '@iris/react-components/Sheet';

import PriceHistoryTimeline from '@/components/PriceHistoryTimeline';

/**
 * Renders the price history timeline with formatted data for display in the sheet.
 *
 * @param {Array} pricingHistory - Array of pricing history objects with dateUpdated and price properties
 * @returns {JSX.Element} Rendered timeline component with formatted pricing data
 */
const renderPriceHistory = (pricingHistory) => {
    const pricingHistoryLocal = [];
    pricingHistory?.slice(-4)?.forEach((item) => {
        pricingHistoryLocal.push({ label: item.dateUpdated, value: item.price });
    });

    return (
        <PriceHistoryTimeline data={pricingHistoryLocal} />
    );
};

/**
 * PriceHistorySheet displays a modal sheet showing the price change timeline for a vehicle.
 * It renders an Iris Sheet component with a timeline visualization of up to 4 recent price changes.
 * The component validates pricing history data and only renders when valid data and trigger are provided.
 *
 * @component
 * @param {Object} props - The component props
 * @param {JSX.Element} props.trigger - The trigger element that opens the price history sheet when clicked
 * @param {Array} [props.pricingHistory=[]] - Array of pricing history objects containing dateUpdated and price properties
 * @param {string} [props.className=''] - Additional CSS classes to apply to the wrapper div
 * @returns {JSX.Element|null} The price history sheet component or null if invalid data
 */
export default function PriceHistorySheet({ trigger, pricingHistory = [], className = '' }) {
    if (!trigger || !pricingHistory || !Array.isArray(pricingHistory) || pricingHistory.length === 0) {
        return null;
    }

    return (
        <div
            data-cmp="priceHistorySheet"
            className={className}
        >
            <Sheet
                trigger={trigger}
                desktopPosition="center"
                title="How this price changed"
                bodyClassName="iris:w-full iris:md:w-[376px]"
                modal
            >
                <div>
                    {renderPriceHistory(pricingHistory)}
                </div>
            </Sheet>
        </div>
    );
}
